<template>
  <img class="image" :src="image" :alt="alt">
</template>

<script>
  export default {
    name: 'ImageLoader',
    props: [
      'src', // Image source
      'lazy', // Flag to indicate if the image should be loading lazily
      'alt'
    ],

    /**
     * Once component is mounted, if the image is set to be lazy-loaded, then a new event listener will be registered,
     * listening for the load event on the window. If the document is already ready, then this won't be registered and
     * the image will be loaded immediately
     *
     * If the image isn't set for lazy loading, then it will simply be loaded right away
     */
    mounted: function () {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting || this.hasIntersected) return;

        this.hasIntersected = true;
      })

      // Add class to element indicating that it has loaded, so the CSS animations can reveal the image
      this.$el.addEventListener('load', (e) => {
        e.target.classList.add('loaded')
      })

      observer.observe(this.$el)
    },

    computed: {
      image () {
        return (this.hasIntersected)
          ? (this.$store.getters.canUseWebP)
            ? this.src + '.webp'
            : this.src
          : ''
      }
    },

    data: function () {
      return {
        hasIntersected: false
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// ImageLoader.vue?49b1da1d